// components/RegistrationForm.jsx
import { useState } from "react";

export default function RegistrationForm() {
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);

    setStatus("loading");
    const res = await fetch("https://formspree.io/f/manobgqa", {
      method: "POST",
      body: form,
      headers: {
        Accept: "application/json",
      },
    });

    if (res.ok) {
      setStatus("success");
      e.target.reset();
    } else {
      setStatus("error");
    }
  };

  return (
    <section className="bg-brandBlue text-white font-outfit px-8 py-20 xxs:py-8 xs:py-8  flex items-center justify-center">
      <div className="bg-white/5 backdrop-blur-md p-10 rounded-2xl w-full max-w-xl shadow-lg">
        <h3 className=" text-2xl  mb-[3rem] uppercase tracking-[0.2em] font-normal text-center text-white xxs:text-lg xs:text-lg xxs:mb-[1.5rem] xs:mb-[1.5rem]">
          Register for the Conference
        </h3>

        {status === "success" ? (
          <p className="text-softGreen text-center text-2xl  font-bold">
            🎉 Thank you for registering!
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2">
                Full Name
              </label>
              <input
                type="text"
                name="name"
                required
                className="w-full px-4 py-2 rounded-lg bg-white/10 border border-white/20 focus:outline-none focus:ring-2 focus:ring-softGreen"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Email</label>
              <input
                type="email"
                name="email"
                required
                className="w-full px-4 py-2 rounded-lg bg-white/10 border border-white/20 focus:outline-none focus:ring-2 focus:ring-softGreen"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">
                Job title
              </label>
              <input
                type="text"
                name="jobTitile"
                className="w-full px-4 py-2 rounded-lg bg-white/10 border border-white/20 focus:outline-none focus:ring-2 focus:ring-softGreen"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Company/Organization
              </label>
              <input
                type="text"
                name="organization"
                className="w-full px-4 py-2 rounded-lg bg-white/10 border border-white/20 focus:outline-none focus:ring-2 focus:ring-softGreen"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">Message</label>
              <textarea
                name="message"
                rows="4"
                className="w-full px-4 py-2 rounded-lg bg-white/10 border border-white/20 focus:outline-none focus:ring-2 focus:ring-softGreen"
              ></textarea>
            </div>

            <button
              type="submit"
              disabled={status === "loading"}
              className="w-full py-3 bg-gradient-to-r from-[#00f78f] to-softGreen text-brandBlue font-semibold rounded-xl hover:opacity-90 transition-all"
            >
              {status === "loading" ? "Submitting..." : "Submit Registration"}
            </button>

            {status === "error" && (
              <p className="text-red-500 text-sm text-center mt-2">
                Something went wrong. Please try again.
              </p>
            )}
          </form>
        )}
      </div>
    </section>
  );
}
